/**
 * Created by claudio iozzia on 29/06/2017.
 */
import {AcceptorOutputFn, andAcceptorSingle} from "../../../../models/acceptor/IAcceptor";
import {Acceptor_DcDc_Buck} from "./dcdc_buck_acceptor";
import {Ic} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {ISingleOutput} from "../../../../models/ISpec";
import {Utils} from "../../../../common/utils";
import {acceptSingle_common_Vout} from "./dcdc__common_acceptor";
import {IC_fsw} from "../../../../models/IC_fsw";

export class Acceptor_DcDc_Boost extends Acceptor_DcDc_Buck {

  constructor (ledDcDc: boolean= false) {super(ledDcDc); }

  private acceptSingle_Boost_Vout: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    const dMax = new IC_fsw(ic).dMax;
    const ret = Utils.isValueEmpty(out.voltage) || Utils.isValueEmpty(spec.spec.value.input.max) ||
      out.voltage >= Math.max(ic.vout_min, Math.round(spec.spec.value.input.max / dMax * 100) / 100);

    // console.log("Acceptor_DcDc_Boost acceptSingle_Boost_Vout, boost", ret, out.voltage);
    return ret;
  }


  protected singleOutputV(): AcceptorOutputFn {return andAcceptorSingle([acceptSingle_common_Vout, this.acceptSingle_Boost_Vout]); }
}
